<template>
  <v-row
    ><v-dialog v-model="GET_OpenDeletePersonDialog" persistent max-width="600px"
      ><v-card
        ><v-card-title class="header font-weight-thin text-h5"
          >Do you want to delete &nbsp;
          <b>{{ GET_SelectedPerson.item.name }} </b>
          &nbsp; ?</v-card-title
        ><v-card-text class="card-text"
          ><v-list disabled>
            <v-list-item-content
              ><p
                v-if="
                  GET_SelectedPerson.item.JobInfo &&
                  GET_SelectedPerson.item.JobInfo.JobTitle
                "
              >
                <b>JobTitle:</b> {{ GET_SelectedPerson.item.JobInfo.JobTitle }}
              </p>
              <v-spacer class="pb-3"></v-spacer>
              <p
                v-if="
                  GET_SelectedPerson.item.JobInfo &&
                  GET_SelectedPerson.item.JobInfo.Office
                "
              >
                <b>Office:</b>{{ GET_SelectedPerson.item.JobInfo.Office }}
              </p>
            </v-list-item-content>
          </v-list></v-card-text
        >
        <v-spacer></v-spacer>
        <ErrorMessageAlert
          v-if="alert"
          v-model="alert"
          :text="GET_ErrorMessage.message"
        />
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn depressed color="primary" @click="cancel()"> Cancel </v-btn>
          <v-btn depressed color="primary" @click="deletePerson()">
            Delete
          </v-btn>
        </v-card-actions></v-card
      ></v-dialog
    ></v-row
  >
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import ErrorMessageAlert from "../MessageToUser/ErrorMessageAlert.vue";
export default {
  components: { ErrorMessageAlert },
  data() {
    return { alert: false };
  },
  computed: {
    ...mapGetters("settingStore", [
      "GET_OpenDeletePersonDialog",
      "GET_SelectedPerson",
      "GET_TemplateType",
      "GET_ErrorMessage",
    ]),
  },
  watch: {
    alert(newValue) {
      if (newValue === false) {
        this.SET_ErrorMessage({});
      }
    },
  },
  methods: {
    ...mapMutations("settingStore", [
      "SET_OpenDeletePersonDialog",
      "SET_SelectedPerson",
      "SET_ErrorMessage",
    ]),
    ...mapActions("settingStore", ["DELETE_Person"]),

    cancel() {
      this.SET_OpenDeletePersonDialog(false);
      this.SET_SelectedPerson({});
    },

    async deletePerson() {
      this.alert = false;
      await this.DELETE_Person(this.GET_SelectedPerson);
      if (this.GET_ErrorMessage.alert === true) {
        this.alert = true;
        return;
      }
      this.SET_OpenDeletePersonDialog(false);
      this.SET_SelectedPerson([]);
    },
  },
};
</script>

<style scoped>
.header {
  justify-content: center;
}
.card-text {
  padding: 16px 24px 10px;
  font-weight: 300;
}

button {
  font-weight: 300;
}
</style>